export default "__VITE_ASSET__CeKpMzp0__"